











































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class StripeDetailsPendingModal extends Vue {
  @Prop() onConfirm!: any;
  @Prop() onGoToWithdraw!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleGoToWithdraw() {
    this.handleClose();
    this.onGoToWithdraw();
  }

  async handleConfirm() {
    await this.onConfirm();
    this.handleClose();
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }

  created() {
    segmentIo.modal('Stripe Details Pending');
  }
}
